export const RUN__SET_AREAS = 'RUN__SET_AREAS';
export const RUN__ADD_AREA = 'RUN__ADD_AREA';
// 设置当前选中的区域
export const RUN__SET_CURRENT_AREA = 'RUN__SET_CURRENT_AREA';
// 设置选中区域索引
export const RUN__SET_CURRENT_AREA_INDEX = 'RUN__SET_CURRENT_AREA_INDEX';
// 设置区域选择列表
export const RUN__SET_AREA_PICKER_LIST = 'RUN__SET_AREA_PICKER_LIST';
